const getDefaultState = () => {
	return {
		user: null,
		sign_in_form: {
			email: null,
			password: null
		},
		change_password_form: {
			old_password: null,
			new_password: null,
			confirm_new_password: null
		},
	}
}

const default_state = getDefaultState()

export { default_state }